module.exports = {
  title: 'Snake Game with React Native Skia',
  author: 'Enzo Manuel Mangano',
  date: '2024-10-22',
  slug: 'snake',
  tags: ['skia'],
};
